module.exports = __webpack_public_path__ + "img/Classroom Teacher.6cf0bace.jpg";